import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GaugeModule } from 'angular-gauge';
import { Select2Module } from 'ng2-select2';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatChipsModule,  
  MatInputModule,
  MatSelectModule,
  MatCardModule,
  MatListModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatTabsModule,
  MatProgressSpinnerModule,
  MatNativeDateModule,  
  MatRadioModule,
  MatGridListModule} from '@angular/material';
  import { ChartsModule } from 'ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';

import { ChipsAutocompletComponent } from './chips-autocomplet/chips-autocomplet.component';
import { GaugeComponent } from './gauge/gauge.component';
import { FilterComponent } from './filter/filter.component'
import { SelectLocationComponent } from './select-location/select-location.component';
import { jqxTextAreaComponent } from '../../jqwidgets-scripts/jqwidgets-ts/angular_jqxtextarea';
import { HeaderBackComponent } from './header-back/header-back.component';
import { ChartsExpandComponent } from './charts-expand/charts-expand.component';
import { ChartsDialogComponent } from './charts-dialog/charts-dialog.component';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { SelectAutocompleteComponent } from './select-autocomplete/select-autocomplete.component'
    
import { ApiBasic } from '../services/api-basic'
import { FiltersProvider } from './filters';
import { LocationsService } from '../reportes/locations.service'
import { TagInputModule } from 'ngx-chips';
import { CalendarfilterComponent } from './filter/calendarfilter/calendarfilter.component';
import { SelectRecorridoComponent } from './select-recorrido/select-recorrido.component';

@NgModule({
  imports: [
    CommonModule,
    GaugeModule.forRoot(),
   	MatAutocompleteModule, 
    MatButtonModule,
    MatDialogModule,
    MatChipsModule,  
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    MatRadioModule,
    NgbModule.forRoot(),
    Select2Module,
    FormsModule, 
    ReactiveFormsModule,
    ChartsModule,
    Ng2GoogleChartsModule,
    TagInputModule,
    AgGridModule.withComponents([]),
    MatGridListModule
  ],
  providers:[
    ApiBasic,
    FiltersProvider,
    LocationsService
  ],
  declarations: [
  	ChipsAutocompletComponent,
  	GaugeComponent,
    FilterComponent,
    jqxTextAreaComponent,
    HeaderBackComponent,
    ChartsExpandComponent,
    ChartsDialogComponent,
    MessageDialogComponent,
    SelectAutocompleteComponent,
    SelectLocationComponent,
    CalendarfilterComponent,
    SelectRecorridoComponent
  ],
  exports:[
  	ChipsAutocompletComponent,
  	GaugeComponent,
    FilterComponent,
    jqxTextAreaComponent,
    HeaderBackComponent,
    ChartsExpandComponent,
    MessageDialogComponent,
    SelectAutocompleteComponent,
    CalendarfilterComponent
  ],
  entryComponents:[
    ChartsDialogComponent,
    MessageDialogComponent,
    SelectLocationComponent,
    SelectRecorridoComponent
  ]
})
export class ShareModule { }
